<template>
    <div class="d-inline text-start">
        <a class="text-body disabled-warning pe-2" href="#" title="รายชื่อลูกค้า" v-on:click="openModalCustomer()"><i
                class="fa fa-user"></i></a>
        <div id="modal-customer" class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel2"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">รายชื่อลูกค้า</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex">
                            <input class="form-control form-control-md" type="text" v-model="search"
                                v-on:input="doSearch()" id="customer-search-on-modal" placeholder="ค้นหา" />
                            <a class="btn btn-sm text-primary fs-3" v-on:click="openModalQuickAdd()"><i
                                    class="fa fa-user-plus"></i></a>
                        </div>
                        <div class="row mt-3" style="overflow-y: scroll; max-height: 500px" id="collapse-container">
                            <template v-for="(item, i) in customers">
                                <div class="col-12 border-bottom py-3" data-bs-toggle="collapse"
                                    v-bind:href="`#collapse${i}`" role="button" aria-expanded="false" :key="i">
                                    <div class="d-flex justify-content-between align-content-center">
                                        <p class="m-0 align-self-center">
                                            <i class="fa fa-angle-right text-muted"></i>
                                            {{ item.fullname }}
                                        </p>
                                        <button v-bind:class="`btn btn-sm btn-outline-primary ${selectedCustomer != null &&
                                            selectedCustomer.id == item.id
                                            ? 'bg-primary text-white'
                                            : ''
                                            }`" v-on:click="chooseCustomer(i)">
                                            {{
                                                selectedCustomer != null &&
                                                    selectedCustomer.id == item.id
                                                    ? "เลือกแล้ว"
                                                    : "เลือกลูกค้า"
                                            }}
                                        </button>
                                    </div>
                                    <div class="collapse text-start" v-bind:id="`collapse${i}`"
                                        data-bs-parent="#collapse-container">
                                        <span class="text-secondary fs-sm">เบอร์โทร: {{ item.phone }}</span>
                                        <span class="text-secondary fs-sm">เพศ: {{ item.gender == "man" ? "ชาย" : "" }}
                                            {{ item.gender == "woman" ? "หญิง" : "" }}
                                            {{
                                                item.gender == "unknown" || item.gender == null
                                                    ? "ไม่ระบุ"
                                                    : ""
                                            }}
                                        </span>
                                        <br />
                                        <span class="text-secondary fs-sm">อีเมล: {{ item.email ? item.email : "-"
                                        }}</span>
                                        <span class="text-secondary fs-sm">ที่อยู่: {{ item.address ? item.address : "-"
                                        }}</span>
                                        <br />
                                        <span class="text-secondary fs-sm">น้ำหนัก: {{ item.weight ? item.weight : "-"
                                        }}
                                        </span>
                                        <span class="text-secondary fs-sm">ส่วนสูง: {{ item.height ? item.height : "-"
                                        }}
                                        </span>
                                        <br />
                                        <span class="text-secondary fs-sm">อายุ: {{ item.age ? item.age : "-" }}
                                        </span>
                                        <br />
                                        <span class="text-secondary fs-sm">ปัจจัยเสี่ยง:
                                            {{
                                                item.health_risk_factors
                                                    ? item.health_risk_factors
                                                    : "-"
                                            }}
                                        </span>
                                        <br />
                                        <button class="btn btn-sm btn-outline-secondary"
                                            v-on:click="editCustomer(item.id)">
                                            แก้ไขข้อมูลลูกค้า
                                        </button>
                                        <button class="btn btn-sm btn-outline-secondary" v-on:click="orders(item.id)">
                                            รายละเอียด
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                            ยกเลิก
                        </button>
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                            v-on:click="setCustomer()">
                            ตกลง
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal-quick-add" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">เพิ่มข้อมูลค้าแบบเร็ว</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row gy-2">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="">ชื่อ-สกุล<span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="">เบอร์โทร <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model="phone">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="">อีเมล</label>
                                    <input type="email" class="form-control" v-model="email">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="">เลขบัตรประจำตัวประชาชน</label>
                                    <input type="text" class="form-control" v-model="tax_no">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="">วันเกิด</label>
                                    <input type="date" class="form-control" v-model="birth_date">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="">ที่อยู่</label>
                                    <textarea class="form-control" name="address" id="address"
                                        v-model="address"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-alt-primary"
                            v-on:click="getDataFromCardReader()">ดึงข้อมูลจากเครื่องอ่านบัตร</button>
                        <a class="btn btn-secondary disabled-warning" target="_blank"
                            :href="urlCreateCustomer">เพิ่มแบบละเอียด</a>
                        <button type="button" class="btn btn-primary" v-on:click="saveCustomer()">บันทึก</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { pullDataFromIDCard } from "../../idcard_reader"
export default {
    name: "modal-customer",
    props: ["urlGetCustomer", "urlCreateCustomer", 'customerTypes'],
    data() {
        return {
            customers: [],
            selectedCustomer: null,
            search: "",
            name: null,
            phone: null,
            email: null,
            tax_no: null,
            address: null,
            birth_date: null
        };
    },
    methods: {
        async getDataFromCardReader() {
            try {
                window.loading_on();
                let data = await pullDataFromIDCard()
                this.name = `${data.title_th} ${data.first_name_th} ${data.last_name_th}`
                this.tax_no = data.citizen_id
                this.birth_date = data.birth_date
                this.address = data.address
            } catch (error) {
                window.loading_off();
            }
            window.loading_off();

        },
        openModalCustomer() {
            $("#modal-customer").modal("show");
        },
        searchCustomers: _.debounce(async (_this) => {
            let res = await axios.get(_this.urlGetCustomer, {
                params: {
                    search: _this.search,
                },
            });
            _this.customers = res.data;
        }, 1000),
        doSearch() {
            this.searchCustomers(this);
        },
        chooseCustomer(index) {
            this.selectedCustomer = this.customers[index];
        },
        setCustomer() {
            if (this.selectedCustomer == null) return;
            let generics = this.selectedCustomer.generics.map((item) => item.name);
            generics = generics.toString().replaceAll(",", ", ");
            let product_names = this.selectedCustomer.drug_allergy;
            if (product_names == null || product_names == "") {
                product_names = "";
            }
            if (this.selectedCustomer) {
                if (generics.length > 0 || product_names.length > 0) {
                    mySwal.fire({
                        title: "ลูกค้ามีประวัติแพ้ยา",
                        html: `
                        <p class='mb-1'>
                            ชื่อสามัญของยาที่แพ้
                            <b>${generics ? generics : "ไม่มี"}</b>
                        </p>
                        <p class='mb-1'>
                            ชื่อสามัญของยาที่แพ้
                            <b>${product_names ? product_names : "ไม่มี"}</b>
                        </p>
                        <p class='mb-1'>
                            โรคประจำตัว
                            <b>${this.selectedCustomer.congenital_disease ??
                            "ไม่มี"
                            }</b>
                        </p>
                        `,
                        icon: "warning",
                    });
                }
                this.$emit("confirm", this.selectedCustomer);
            } else {
                mySwal.fire({
                    title: "ไม่ได้เลือกสมาชิก",
                    text: "หากต้องการใช้สิทธิบัตรทองหรือเป็นสมาชิกกรุณาเลือก",
                    icon: "error",
                });
            }
            this.selectedCustomer = null;
        },
        editCustomer(id) {
            window.open(`/customer/${id}/edit`);
        },
        orders(id) {
            window.open(`/customer/${id}/orders`);
        },
        openModalQuickAdd() {
            $("#modal-customer").modal("hide");
            $("#modal-quick-add").modal("show");
        },
        saveCustomer() {
            if (!this.name) {
                mySwal.fire({
                    title: "กรอกข้อมูลไม่ครบถ้วน",
                    text: "กรุณากรอก ชื่อ-สกุล",
                    icon: "warning",
                })
                return;
            }
            if (!this.phone) {
                mySwal.fire({
                    title: "กรอกข้อมูลไม่ครบถ้วน",
                    text: "กรุณากรอก เบอร์โทร",
                    icon: "warning",
                })
                return;
            }
            this.$emit("add-new-customer", {
                name: this.name,
                phone: this.phone,
                email: this.email,
                tax_no: this.tax_no,
                birth_date: this.birth_date,
                address: this.address,
            });
            $("#modal-quick-add").modal("hide");
        }
    },
};
</script>
<style scoped>
#collapse-container>div[aria-expanded="true"]>div>p>i {
    transform: rotate(90deg);
}

#collapse-container>.collapsed>div>p>i {
    transform: rotate(0deg);
}
</style>
